import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import CatalogoService from '../../API/CatalogoService';
import { setTipoConducta } from '../../redux/catalog/catalogSlice';

const defaultFormSchema = Yup.object().shape({});
const initialValues = {
  folio: '',
  estatusDenuncia: '',
  tipoSugerencia: 1,
  tipoDenunciaMejora: '',
  tipoConducta: '',
};

const BandejaSearch = ({ setDataFilters }) => {
  const { catalogs } = useAppSelector(({ catalogReducer }) => catalogReducer);
  const dispatch = useAppDispatch();

  const submitForm = ({ values }) => {
    const paramsSelected = {};
    if (values?.folio) paramsSelected.folio = values.folio;
    if (values?.estatusDenuncia) paramsSelected.estatusDenuncia = values.estatusDenuncia;
    if (values?.tipoSugerencia) paramsSelected.tipoSugerencia = values.tipoSugerencia;
    if (values?.tipoDenunciaMejora) paramsSelected.tipoDenunciaMejora = values.tipoDenunciaMejora;
    if (values?.tipoConducta) paramsSelected.tipoConducta = values.tipoConducta;

    searchData(paramsSelected);
  };

  const searchData = (objParams = {}) => {
    /**
     *  ?folio=UXDVN75975
     *  &tipoSugerencia=1
     *  &tipoDenunciaMejora=2
     *  &estatusDenuncia=1
     */
    setDataFilters(objParams);
  };

  const { values, handleBlur, setFieldValue, handleChange, handleSubmit, resetForm } = useFormik({
    initialValues,
    validationSchema: defaultFormSchema,
    onSubmit: (values, actions) => submitForm({ values, actions }),
    validateOnChange: false,
  });

  const clearFilters = () => {
    setDataFilters({});
  };

  useEffect(() => {
    if (values.tipoDenunciaMejora) {
      setFieldValue('tipoConducta', '');
      CatalogoService.consultaCatalogo({ dispatch, path: `/conducta/${values.tipoDenunciaMejora}` }).then(response => {
        setTipoConducta(dispatch, response);
      });
    }
  }, [values.tipoDenunciaMejora]);

  return (
    <Container className="container mb-2">
      <form id="bandejaSearchForm" className="filtros" onSubmit={handleSubmit}>
        {/* 1 */}
        <Row>
          <Col xs={12} sm={6} md={2} className="mb-2">
            <Form.Control
              placeholder="Folio"
              type="text"
              name="folio"
              onChange={handleChange}
              value={values.folio}
              onBlur={handleBlur}
            />
          </Col>

          <Col xs={12} sm={6} md={3} className="mb-2">
            <Form.Control
              as="select"
              name="estatusDenuncia"
              onChange={handleChange}
              value={values.estatusDenuncia}
              onBlur={handleBlur}
            >
              <option value="">Selecciona el estatus</option>
              {!!catalogs?.estatus?.length &&
                catalogs?.estatus.map(option => (
                  <option key={option.id} value={option.id}>
                    {option.value}
                  </option>
                ))}
            </Form.Control>
          </Col>

          <Col xs={12} sm={6} md={4} className="mb-2">
            <Form.Control
              as="select"
              name="tipoDenunciaMejora"
              onChange={handleChange}
              value={values.tipoDenunciaMejora}
              onBlur={handleBlur}
            >
              <option value="" label="Selecciona el comportamiento" />
              {!!catalogs?.tipoDenunciaMejora?.length &&
                catalogs?.tipoDenunciaMejora.map(option => (
                  <option key={option.id} value={option.id}>
                    {option.value}
                  </option>
                ))}
            </Form.Control>
          </Col>

          {!!catalogs?.tipoConducta?.length && (
            <Col xs={12} sm={6} md={4} className="mb-2">
              <Form.Control
                as="select"
                name="tipoConducta"
                onChange={handleChange}
                value={values.tipoConducta}
                onBlur={handleBlur}
              >
                <option value="" label="Selecciona una conducta" />
                {catalogs?.tipoConducta?.map(option => (
                  <option key={option.id} value={option.id}>
                    {option.value}
                  </option>
                ))}
              </Form.Control>
            </Col>
          )}

          <Col xs={8} className="mb-2 mt-4  d-flex justify-content-start">
            <Button form="bandejaSearchForm" type="submit" className="btn btn-truper m-0 mr-2 w-auto">
              Buscar
            </Button>
            <Button
              variant="secondary"
              className="btn-truper-secondary m-0 w-auto"
              onClick={() => {
                resetForm();
                clearFilters();
              }}
            >
              Limpiar Filtros
            </Button>
          </Col>
        </Row>
      </form>
    </Container>
  );
};

export default BandejaSearch;
